import React from "react"

import SEO from "../components/seo"
import Header from "../components/Header"
import Arrow from './../images/icons/drop-down.png'
import Pin from './../images/icons/pin.png'
import Envelope from './../images/icons/envelope.png'
import Map from './../images/map.jpg'
import Contact from './../images/contact.jpg'
import Network from './../images/icons/network.png'
import Instagram from './../images/icons/instagram.png'
import Telegram from './../images/icons/telegram.png'
import Aparat from './../images/icons/aparat.png'
// import Whatsapp from './../images/icons/whatsapp.png'
import Footer from "../components/Footer"
import Input from "../components/Input"
import TextArea from "../components/TextArea"
import ScrollSpy from './../components/ScrollSpy'
import { useState } from "react"
import { toast } from "react-toastify"
import { validateEmail, apiCall } from "../../Helper"

export default () => {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [subject, setSubject] = useState('')
  const [text, setText] = useState('')

  function submitForm(e) {
    e.preventDefault()
    if (name && email && subject && text) {
      if (validateEmail(email)) {
        apiCall({
          url: '/adminPanel/contactUs', method: 'post',
          data: { name, email, subject, text }
        }).then(res => {
          if (res && res.data && res.data.code === 0) {
            setName('')
            setEmail('')
            setSubject('')
            setText('')
            toast.success('درخواست با موفقیت ارسال شد')
          } else toast.error('مشکل در سیستم')
        }).catch(err => toast.error('مشکل در سیستم'))
      } else toast.warn('فرمت ایمیل صحیح نمی باشد')
    } else toast.warn('همه فیلد ها باید پر شود')
  }

  return (
    <div className="slideInTop">
      <SEO title="ارتباط با ما" />
      <Header />
      <ScrollSpy />
      <div id="parrent" className="overflow-auto rtl">
        <div className="mx-auto" style={{ height: 'calc(100vh - var(--top-nav-height))' }}>
          <div className="px-64"
            style={{ height: 'calc(100vh - var(--top-nav-height))', backgroundAttachment: 'fixed', maxHeight: 700, backgroundImage: `url(${Contact})`, backgroundPosition: '0 85px', backgroundSize: 'cover' }}>
            <div className="absolute" style={{
              bottom: 0,
              right: 'calc(50% - 22px)'
            }}>
              <button className="bd-none bg-none icon-button notifyMe" style={{ filter: 'drop-shadow(0px -4px 0px #464953)' }}
                onClick={() => document.getElementById('content-holder').scrollIntoView({ behavior: 'smooth' })}>
                <span className="bg-bg icon-mask thumb blocked" style={{
                  WebkitMaskImage: `url(${Arrow})`,
                  WebkitMaskSize: 'contain'
                }} />
              </button>
            </div>
          </div>
          <div id="content-holder" className="container pt-64">
            <section className="px-64 py-45">
              <div className="pb-45 text-center">
                <span className="font-14">ارتباط با ما</span>
                <h3 className="text-shadow font-24" style={{ marginRight: -20 }}>
                  <img className="icon-sm ml-8" style={{ transform: 'rotate(90deg)' }} src={Arrow} alt="" />
                  به اندازه یک تماس از هم فاصله داریم
                </h3>
              </div>

              <div className="pb-32">
                <h5 className="text-shadow font-16 mt-0 iran-sans-light" style={{ marginRight: -20 }}>
                  <img className="icon-sm ml-8 icon-shadow" style={{ marginBottom: -3 }} src={Pin} alt="" />
                  دفاتر:
                </h5>
                <div className="px-45">
                  <div className="flexed">
                    <p className="mb-5 text-light flex-7 font-14">تهران: میدان ولیعصر، خیابان مینو، تقاطع خیابان مظفر، ساختمان ۱۰۵</p>
                    <p className="mb-5 flex-2 font-14">
                      <span className="text-light">
                        شماره تماس:
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a href="tel:00982191090130" className="text-light" dir="ltr">021-91090130</a>
                    </p>
                  </div>
                  {/* <div className="flexed">
                    <p className="mb-5 text-light flex-4">تبریز:‌ خیابان آزادی، جنب شیخ الرییس، کوی پارسا، ساختمان پارسا، پلاک۸، طبقه اول</p>
                    <p className="mb-5 flex-1">
                      <span className="text-light">
                        شماره تماس:
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span className="text-light" dir="ltr">۰۴۱ - ۳۳۳ ۴۶۹ ۰۷</span>
                    </p>
                  </div>
                  <div className="flexed">
                    <p className="mb-5 text-light flex-4">جلفا: منطقه آزاد ارس، جلفا، خیابان امام خمینی، پاساژ دنیز، طبقه اول واحد۱۱۲</p>
                    <p className="mb-5 flex-1">
                      <span className="text-light">
                        شماره تماس:
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span className="text-light" dir="ltr">۰۹۱۴ ۴۱۹ ۹۹۱۸</span>
                    </p>
                  </div> */}
                </div>
              </div>
              <div className="py-45 flexed justify-between">
                <div>
                  <h5 className="text-shadow font-16 m-0 inline-blocked iran-sans-light" style={{ marginRight: -20 }}>
                    <img className="icon-sm ml-8 icon-shadow" style={{ marginBottom: -3 }} src={Envelope} alt="" />
                    ایمیل:
                  </h5>
                  &nbsp;&nbsp;&nbsp;
                  <a href="mailto:info@digimaliat.com" className="font-16">info@digimaliat.ir</a>
                </div>
                <div className="flexed align-c">
                  <h5 className="text-shadow font-16 m-0 inline-blocked iran-sans-light" style={{ marginRight: -20 }}>
                    <img className="icon-sm ml-8 icon-shadow" style={{ marginBottom: -3, width: 22 }} src={Network} alt="" />
                    ما در شبکه های اجتماعی:
                  </h5>
                  <a href="https://t.me/digimaliat" target="_blank" className="mr-16">
                    <img className="thumb" src={Telegram} alt="" />
                  </a>
                  {/* <a href="/" className="mr-16">
                    <img className="thumb" src={Whatsapp} alt="" />
                  </a> */}
                  <a href="https://instagram.com/digimaliat" target="_blank" className="mr-16">
                    <img className="thumb" src={Instagram} alt="" />
                  </a>
                  <a href="https://www.aparat.com/digimaliat" target="_blank" className="mr-16">
                    <img className="thumb" src={Aparat} alt="" />
                  </a>
                </div>
              </div>
              {/* <div className="py-45">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d809.9281237903867!2d51.410863829255014!3d35.70869199876176!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzXCsDQyJzMxLjMiTiA1McKwMjQnNDEuMSJF!5e0!3m2!1sen!2s!4v1590469462297!5m2!1sen!2s"
                  className="w-100"
                  width="600" height="450" frameBorder="0" allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
              </div> */}
              <div className="py-45">
                {/* <img className="w-100" src={Map} alt="" /> */}
                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d1120.0699740126972!2d51.40569061262594!3d35.710723579454246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2s!4v1745079292443!5m2!1sen!2s"
                  className="w-100"
                  width="600" height="450" frameBorder="0" allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>
              </div>
            </section>

            <section className="px-64 py-45">
              <div className="pb-45 text-center">
                <h3 className="text-shadow font-20 iran-sans-lighter" style={{ marginRight: -20 }}>
                  از طریق فرم زیر با ما در ارتباط باشید
                </h3>
              </div>

              <form onSubmit={submitForm}>
                <div className="grid" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gridGap: 32 }}>
                  <Input className="bg-light" type="text"
                    placeholder="نام و نام خانوادگی:" onChange={setName} value={name} />
                  <Input className="bg-light" type="text"
                    placeholder="ایمیل:" onChange={setEmail} value={email} />
                </div>
                <div className="grid pt-32" style={{ gridGap: 32 }}>
                  <Input className="bg-light" type="text"
                    placeholder="موضوع:" onChange={setSubject} value={subject} />
                  <TextArea className="bg-light" type="text"
                    placeholder="متن پیام:" onChange={setText} value={text} />
                </div>

                <div className="pt-32 ltr">
                  <button className="bd-none iran-sans inline-flexed fl-c radius-8 font-13 mr-16 shadow-sm" style={{ width: 164, height: 50, backgroundColor: '#ececec' }}
                  >ارسال پیام</button>
                </div>
              </form>
            </section>
          </div>
          <Footer />
        </div>
      </div>
    </div >
  )
}
